<form [formGroup]="information" class="text-dark">
    <div class="row">
        <div class="form-group col-md-12 col-sm-12">
            <label for="email">Email Address</label>
            <input class="form-control" type="email" id="email" autocomplete="off" formControlName="email" placeholder="Enter email">
            
            @if (email.invalid && email.dirty) {
                <span class="text-danger">Email Address Invalid</span>
            }

            @if (userCorporateList.length > 0 && !newCorporate) {
                <div class="p-2">
                    <span class="text-warning">Your email address exists for the following corporations.</span>
                    <ul class="list-group my-2">
                        @for (corporate of userCorporateList; track corporate) {
                            <li class="list-group-item"> <a href="https://{{corporate.corporateURL}}/#/login" class="text-dark">{{corporate.name}}</a></li>
                        }
                    </ul>
                    <span class="text-dark">Looking for a different corporation? Reach out to your admin or create a new corporation.</span>
                    <button class="btn btn-block btn-primary btn-sm mt-1" (click)="showNewUserForm(true)">Create a New Corporation</button>
                </div>
            }
        </div>
    </div>
    @if (!userId || newCorporate) {
        <div class="row">
            <div class="form-group col-md-6 col-sm-12">
                <label for="firstName">First Name</label>
                <input class="form-control" type="text" id="firstName" formControlName="firstName" autocomplete="off" placeholder="Enter First Name">
                @if (firstName.invalid && firstName.dirty) {
                <span class="text-danger">First Name Invalid</span>
                }
            </div>
            <div class="form-group col-md-6 col-sm-12">
                <label for="lastName">Last Name</label>
                <input class="form-control" type="text" id="lastName" formControlName="lastName" placeholder="Enter Last Name" autocomplete="off">
                @if (lastName.invalid && lastName.dirty) {
                <span class="text-danger">Last Name Invalid</span>
                }
            </div>
            <!-- password input -->
            @if (!passwordSet) {
                <div class="form-group col-md-6 col-sm-12">
                    <label for="password">Password</label>
                    <div class="input-group input-group-merge">
                        <input class="form-control" formControlName="password" [type]="typePassword" id="password" placeholder="Enter password">
                        <div class="input-group-append" (click)="changeTypePassword()" id="changeType">
                            <div class="input-group-text">
                                @if (typePassword=='text') {
                                    <span class="uil uil-eye"></span>
                                }
                                @if (typePassword!='text') {
                                    <span class="uil uil-eye-slash"></span>
                                }
                            </div>
                        </div>
                    </div>
                    @if (password.invalid && password.dirty) {
                        <span class="text-danger">Password Invalid: Must contain at least 12 characters, uppercase, lowercase, numbers and special characters (* - $%)</span>
                    }
                </div>
            }
            <div class="form-group col-md-6 col-sm-12">
                <label>Primary Phone Number</label>
                <input class="form-control" formControlName="phone" type="text" autocomplete="off" placeholder="Enter primary phone number">
                @if (phone.invalid && phone.dirty) {
                <span class="text-danger">Primary Phone Number
                    Invalid</span>
                }
            </div>
            <div class="form-group col-md-6 col-sm-12">
                <label>Dealer Number</label>
                <input class="form-control" formControlName="dealerNumber" type="text" autocomplete="off" placeholder="GDN">
                @if (dealerNumber.invalid && dealerNumber.dirty) {
                <span class="text-danger">GDN Invalid</span>
                }
            </div>
            <div class="form-group col-md-6 col-sm-12">
                <label>Company Position</label>
                <select class="form-control" formControlName="position">
                    @for (position of ['Owner','Manager','Employee']; track position) {
                    <option [value]="position">{{position}}
                    </option>
                    }
                </select>
            </div>
            <!-- corporate -->
            <div class="form-group col-md-12 col-sm-12">
                <label for="name">Corporate Name</label>
                <input class="form-control" formControlName="companyName" type="text" id="name" autocomplete="off" (change)="setCorporateURL()" placeholder="Enter Corporate Name">
                @if (companyName.invalid && companyName.dirty) {
                <span class="text-danger">Corporate Name Invalid</span>
                }
            </div>
            <div class="form-group col-md-12 col-sm-12">
                <label for="corporate">Corporate URL</label>
                <div class="input-group input-group-merge">
                    <input (change)="preValidateCorporateURL()" class="form-control" formControlName="corporateURL" type="text" id="corporateURL" autocomplete="off" placeholder="Enter Corporate URL">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="text-muted">.rockitdms.com</span>
                        </div>
                    </div>
                </div>
                @if (corporateURL.invalid && corporateURL.dirty) {
                <span class="text-danger">The Corporate URL should be
                    unique and have no spaces or special characters. Please enter a valid Corporate URL.</span>
                }
            </div>
            <div class="form-group col-md-12 col-sm-12">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="accept" formControlName="acceptTerms">
                    <label class="custom-control-label" for="accept"><b>I accept</b><span class="text-muted ml-1">Terms and
                            Conditions</span></label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 text-center">
                <button (click)="registerCorporation()" class="btn btn-block btn-primary btn-sm" [disabled]="information.invalid">Register</button>
            </div>
        </div>
    }
</form>